/**
* Created by kongwm.kong on 2017/7/20.
*/
<template>
    <div class="callback_page_wrap">
        <div class="layout_n">
            <div class="callback_wrap">
                <div class="title">找回密码</div>
                <!--进程开始-->
                <div class="process_wrap">
                    <div class="liner">
                        <div :class="{ 'line':true, 'line2': step2, 'line3': step3, 'line4': step4 }"></div>
                    </div>
                    <!--步骤开始-->
                    <div class="step_wrap clearfix" >
                        <div :class="{ 'step': true, 'now': step1 , 'prev': step2||step3||step4}">
                            <div class="step_line">
                                <div :class="{'first': step2||step3||step4 , 'line': true}"></div>
                                <div class="radius_wrap">
                                    <div class="radius">1</div>
                                </div>
                            </div>
                            <div class="text">账户登录</div>
                        </div>
                        <div :class="{ 'step': true, 'now': step2 , 'prev': step3||step4}">
                            <div class="step_line">
                                <div class="line"></div>
                                <div class="radius_wrap">
                                    <div class="radius">2</div>
                                </div>
                            </div>
                            <div class="text">验证身份</div>
                        </div>
                        <div :class="{ 'step': true, 'now': step3 , 'prev': step4}">
                            <div class="step_line">
                                <div class="line"></div>
                                <div class="radius_wrap">
                                    <div class="radius">3</div>
                                </div>
                            </div>
                            <div class="text">重置密码</div>
                        </div>
                        <div :class="{ 'step': true, 'now': step4}">
                            <div class="step_line">
                                <div class="line"></div>
                                <div class="radius_wrap">
                                    <div class="radius">4</div>
                                </div>
                            </div>
                            <div class="text">完成</div>
                        </div>
                    </div>

                </div>
                <!--进程结束-->
                <!--第一步开始-->
                <div class="pro_step_1 pro_step" v-show="step1">
                    <form @submit.prevent="next1('next1')" data-vv-scope="next1">
                        <div class="filed">
                            <div class="input_wrap">
                                <input type="text" placeholder="请输入用户名／手机号" name="username1" v-validate="'required'" v-model="username">
                                <span class="err" v-show="errors.has('next1.username1')">{{errors.first('next1.username1')}}</span>
                            </div>
                        </div>
                        <div class="btn go_next"><button type="submit">下一步</button></div>
                        <div class="err" >{{msg.usernameMsg}}</div>
                    </form>
                </div>
                <!--第二步开始-->
                <div class="pro_step_2 pro_step" v-show="step2">
                    <form @submit.prevent="next2('next2')" data-vv-scope="next2">
                        <div class="showPhone">手机号码：{{phone}}</div>
                        <div class="filed">
                            <div class="input_wrap">
                                <input type="text" placeholder="请输入验证码"  name="validImg" v-validate="'required'" v-model="validImg">
                                <span class="err" v-show="errors.has('next2.validImg')">{{errors.first('next2.validImg')}}</span>

                            </div>
                            <div class='img_valid_wrap'>
                                <div class="img_valid" @click="getImgCode" ><img :src="imgSrc" width="110" height="40"></div>
                            </div>
                        </div>
                        <div class="filed">
                            <div class="input_wrap">
                                <input type="text" placeholder="请输入手机验证码" name="validCode" v-validate="'required|number'" v-model="valid_phone">
                                <span class="err" v-show="errors.has('next2.validCode')">{{errors.first('next2.validCode')}}</span>
                                <span class="err" v-show="!errors.has('next2.validCode')">{{msg.valid_phone}}</span>
                                <span class="err" v-show="!errors.has('next2.validCode') && msg.validCodeFlag">{{msg.validCodeMsg}}</span>
                            </div>
                            <div class='img_valid_wrap'>
                                <div class="img_valid">
                                    <button :class="['send-code', {'disabled':disabled}]" id="sendCode" @click="sendCode">发送验证码</button>
                                </div>
                                <!--<div class="img_valid"><send-code @changeErrTipFlag="changeErrTipFlag"  @changeImgCode="getImgCode" :imageCode="validImg" :validPhone="errors.has('next2.validImg')" ></send-code></div>-->
                            </div>
                        </div>

                        <div class="btn go_next"><button type="submit">下一步</button></div>
                        <div class="err">{{errMsg}}</div>
                    </form>
                </div>
                <!--第三步开始-->
                <div class="pro_step_3 pro_step" v-show="step3">
                    <form @submit.prevent="next3('next3')" data-vv-scope="next3">
                        <div class="filed" @mouseenter="showTip=true" @mouseleave="showTip=false">
                            <div class="input_wrap">
                                <input type="password" placeholder="设置你的登录密码" @blur="isEqual" name="password" v-validate="'required|password'" v-model="password">
                                <span class="err" v-show="errors.has('next3.password')">{{errors.first('next3.password')}}</span>
                                <div class="passTip-show">
                                    <pass-tip :showFlag="showTip"></pass-tip>
                                </div>
                            </div>
                        </div>
                        <div class="filed">
                            <div class="input_wrap">
                                <input type="password" placeholder="请再次输入您的密码" @blur="isEqual" name="password1" v-validate="'required|password'" v-model="password1">
                                <span class="err" v-show="errors.has('next3.password1')">{{errors.first('next3.password1')}}</span>
                                <span class="err" v-show="!errors.has('next3.password1') && msg.passwordFlag">两次密码输入的不一致</span>
                            </div>
                        </div>
                        <div class="btn go_next"><button type="submit">下一步</button></div>
                        <div class="err">{{errMsg}}</div>
                    </form>
                </div>
                <!--第四步开始-->
                <div class="pro_step_4 pro_step" v-show="step4">
                    <div class="success_wrap">
                        <img src="../../assets/img/common/icon_suc.png">
                    </div>
                    <p class="ps">恭喜您成功找回密码</p>
                    <router-link class="go_next a_login" to="/login">前往登录</router-link>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//    import sendCode from '../../components/common/sendCode'
    import passTip from './passTip'
    import CountDown from  '../../assets/js/common/countdown';
    export default {
        // 注册组件
        components: {
            passTip
        },
        data (){
            return {
                step1: true,
                step2: false,
                step3: false,
                step4: false,
                phone: '157****5892',
                username:'',
                password:'',
                password1: '',
                showTip: false,
                errMsg: '',
                validImg: '',
                msg: {
                    usernameMsg: '',
                    valid_phone: '',
                    validCodeFlag: false,
                    validCodeMsg:'图形验证码不正确',
                    passwordFlag: false,
                },
                imgSrc: '/v1/security-code/image'
            }
        },
        mounted: function (){
        },
        methods: {
            sendCode(e){
                e.preventDefault();
                this.authCode =  new CountDown({
                    id: 'sendCode',
                    disabledClass: 'send-code disabled',
                    normalClass:'send-code ',
                    clickFont: '秒后重新发送',
                    afterFont: '发送验证码',
                    path: '/',
                    pathFlag: '11'
                });
//                console.log(this.validImg);
                if(this.validImg && this.validImg!=''){
                    let url = `/security-code/sendPhoneSecurityCode?imageCode=${this.validImg}`;
                    this.$http.request({
                        url: url
                    }, response=>{
                        if(response.data.code===401){
                            let obj = {
                                flag: true,
                                msg: response.data.message
                            };
                            this.changeErrTipFlag(obj);  //出错后的提示
                            this.getImgCode();
                        } else if(response.data.code == 200){
                            this.authCode.startCount();
                            this.changeErrTipFlag({flag: false, msg: ''});
                        }else{
                            this.getImgCode();
                        }
                    }, err=>{
                        this.getImgCode();
                    });
                } else {
                    this.changeErrTipFlag({flag: true, msg: '请输入验证码'});
                }

            },
            /*验证码出错后提示*/
            changeErrTipFlag(obj){
                this.msg.validCodeFlag = obj.flag;
                this.msg.validCodeMsg = obj.msg;
            },
            getImgCode(){
                this.imgSrc = '/v1/security-code/image?'+ Math.random();
                this.valid_img = '';
            },
            isEqual(){
                if(this.password != this.password1 && this.password1.length && this.password.length){
                    this.msg.passwordFlag = true;
                } else {
                    this.msg.passwordFlag = false;
                }
            },
            next1(scope){
                this.$validator.validateAll(scope).then(result => {
                    if(result){
                        this.$http.request({
                            url: `/account/changePwd/key_${this.username}/user`
                        }, response => {
                            if(response.data.code === 200){
                                this.phone = response.data.data.phone;
                                this.step1 = false;
                                this.step2 = true;
                                this.msg.usernameMsg = '';
                            } else if(response.data.code === 401){
                                this.msg.usernameMsg = response.data.message;
                            }
                        }, err => {
                            this.msg.usernameMsg = '系统繁忙';
                        });
                    }
                });
            },
            next2(scope){
                this.$validator.validateAll(scope).then(result => {
                    if(result){
                        this.$http.request({
                            url: `/account/changePwd/securityCode_${this.valid_phone}`
                        }, response => {
                            if (response.data.code === 200) {
                                this.step2 = false;
                                this.step3 = true;
                                this.errMsg = '';
                            } else if(response.data.code === 401){
                                this.errMsg = response.data.message;
                            }
                        }, err => {
                            this.errMsg = '系统繁忙'
                        });
                    }

                });

            },
            next3(scope){
                this.$validator.validateAll(scope).then(result => {
                    if(result && !this.msg.passwordFlag) {
                        this.$http.request({
                            url: `/account/changePwd/newPwd_${this.password}`,
                            method: 'put'
                        }, response => {
                            if (response.data.code === 200) {
                                this.step3 = false;
                                this.step4 = true;
                                this.errMsg = '';
                            } else if(response.data.code === 401){
                                this.errMsg = response.data.message;
                            }
                        }, err => {
                            this.errMsg = '系统繁忙'
                        });
                    }
                });

            },
        },
        watch:{

        }
    };
</script>
<style lang="scss" type="text/scss" scoped>
    .callback_page_wrap{
        margin-top:30px;
        margin-bottom: 50px;
        .callback_wrap{
            background: #fff;
            padding-top:40px;
            padding-left:50px;
            height:700px;
            .title{
                font-size: 18px;
                color: $c_3c3;
                letter-spacing: -0.43px;
                border-left: 6px solid $btn_408;
                text-indent: 8px;
                height: 20px;
                line-height: 1;
                margin-bottom:50px;
                padding-top: 2px;
            }
            .process_wrap{
                width:700px;
                margin: 0 auto 60px;
                position:relative;
                .liner{
                    position:absolute;
                    top:16px;
                    left: 0;
                    width:100%;
                    height:6px;
                    background:$c_f5f;
                    border-radius: 100px;
                    .line{
                        background: $c_9ab;
                        border-radius: 100px;
                        height:100%;
                        width:25%;
                        &.line2{
                            width:50%;
                        }
                        &.line3{
                            width:75%;
                        }
                        &.line4{
                            width:100%;
                        }
                    }
                }
                .step{
                    width:175px;
                    float: left;
                    position:relative;
                    &.prev{
                        .step_line {
                            .radius_wrap {
                                .radius {
                                    background: $c_9ab;
                                    color: #fff;
                                }
                            }
                        }
                    }
                    &.now{
                        .line{
                            background:$btn_408;
                        }
                        .step_line{
                            .radius_wrap{
                                .radius{
                                    background: $btn_408;
                                    color: #fff;
                                }
                            }
                        }
                    }
                    .step_line{
                        position:relative;
                        margin-bottom:25px;
                        .line{
                            position:absolute;
                            top:15px;
                            left:0;
                            width:100%;
                            height:6px;
                            border-radius: 100px;
                           // background: $btn_408;
                        }
                        .radius_wrap{
                            position: relative;
                            width:36px;
                            height:36px;
                            margin: 0 auto;
                            border-radius: 50%;
                            background: #D9E7FD;
                            .radius{
                                width:28px;
                                height:28px;
                                margin: 0 auto;
                                top:4px;
                                position:relative;
                                border-radius: 50%;
                                background:#fff;
                                color:$c_b7b;
                                text-align: center;
                                line-height: 28px;
                            }
                        }
                    }
                    .text{
                        font-size: 18px;
                        color: $c_989;
                        text-align: center;
                        line-height: 18px;
                    }
                }
            }
            .pro_step{
                width:330px;
                margin: 0 auto;
                .showPhone{
                    font-size: 16px;
                    color:$c_989;
                    margin-bottom:20px;
                }
            }
            .pro_step_4{
                text-align: center;
                .ps{
                    font-size: 18px;
                    margin-top:30px;
                    color: $btn_408;
                    margin-bottom:20px;
                }
            }
            .a_login{
                display: block;
            }
            .go_next{
                height:40px;
                background: $btn_408;
                text-align:center;
                font-size:18px;
                color:#fff;
                font-weight:bold;
                line-height:40px;
                cursor: pointer;
                button{
                    color:#fff;
                    width:100%;
                    height:100%;
                }
            }
            .filed{
                margin-bottom:20px;
                position:relative;
                border:1px solid $border_bfb;
                .input_wrap{
                    /*height:40px;*/
                    position:relative;
                    input{
                        background: transparent;
                        width:100%;
                        padding:10px 0 10px 20px;
                        color:$c_666;
                        font-size:16px;
                        line-height: 16px;
                    }
                    .passTip-show{
                        position: absolute;
                        top:-12px;
                        left: 103%;
                    }
                    .err{
                        position: absolute;
                        top:10px;
                        left: 340px;
                        width:300px;
                        color:$c_ff5;
                        text-align: left;
                    }
                }
                .img_valid_wrap{
                    position:absolute;
                    top:0;
                    right:0;
                    width:110px;
                    height:100%;
                    background: #f5f5f5;
                    color:$btn_408;
                    font-size:14px;
                    line-height:40px;
                    text-align : center;
                    img{
                        position: absolute;
                        top:0;
                        left:0;
                        width:100%;
                        height:100%;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/user/callback.vue